import React, { useEffect, useState } from 'react';
import { TableBody, TableCell, TableRow, Table, Button, Pagination } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useDispatch, useSelector } from 'react-redux';
// State
import { fetchUserList } from './actions';
import { set_user_details_drawer } from 'Store/reducers/adminReducer';
import { set_users, set_user_details } from 'Store/reducers/userReducer';
import { AppDispatch, RootState } from 'Store/Store';
import { setErrorToastState } from 'Store/action';
// Components
import TableFilter from 'Components/table-filter/table-filter.component';
import { Cell, TableHeader, TABLE_HEADERS } from 'Components/Table/TableUser';
// Types
import { TableFilterObjectTypes } from 'shared/types/TableFilterObject.types';
import { UserType } from 'shared/types/User.types';

export const UserTable: React.FC = (): React.ReactElement => {
  const dispatch = useDispatch<AppDispatch>();
  const users = useSelector((state: RootState) => state?.user?.users);
  const [filters, setFilters] = useState<TableFilterObjectTypes>({
    search: '',
    sort: 'name',
    perPage: 10,
    page: 1,
  });

  useEffect(() => {
    fetchUserList(filters)
      .then(res => {
        if (res.status === 200) {
          dispatch(set_users(res.data));
        }
      })
      .catch(err => {
        dispatch(setErrorToastState(true, 'Something went wrong, please try again in a while.'));
      });
  }, [filters, dispatch]);

  return (
    <Grid container direction="column" spacing={2}>
      <Grid>
        <TableFilter
          title="User List"
          counter={users?.meta?.total}
          setFilters={setFilters}
          filters={filters}
        />
      </Grid>
      <Grid container direction="column" spacing={2}>
        <Grid>
          <Table>
            <TableHeader headers={TABLE_HEADERS} />
            <TableBody>
              {users &&
                users?.data?.length > 0 &&
                users?.data?.map((user: UserType, index: number) => (
                  <TableRow key={index}>
                    <Cell content={user?.id} />
                    <Cell content={user?.first_name} />
                    <Cell content={user?.last_name} />
                    <Cell email={user?.email} />
                    <Cell content={user?.role?.display_name} />
                    <TableCell
                      style={{ padding: '24px 0', borderBottomColor: 'rgba(2, 15, 42, 0.20)' }}>
                      <Button
                        variant="contained"
                        color="secondary"
                        sx={{ backgroundColor: '#326295' }}
                        onClick={() => {
                          dispatch(set_user_details_drawer(true));
                          dispatch(set_user_details(user));
                        }}>
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Grid>
        <Grid container direction="row" justifyContent="flex-end">
          <Pagination
            count={users?.meta?.last_page}
            shape="rounded"
            onChange={(e, page) => {
              setFilters(prevState => ({
                ...prevState,
                page: page,
              }));
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UserTable;
